import React from 'react';
import { useTranslation } from 'react-i18next';
import { RetakeHostProps } from './RetakeHost.type';
import './RetakeHost.scss';
import wemeetClient from '@utils/wemeetClient';

const RetakeHost: React.FC<RetakeHostProps> = () => {
  const { t } = useTranslation();
  const onRetakeHost = () => {
    wemeetClient.hostCtrl.reclaimHost();
  };
  return (
    <li className="retake-host" onClick={onRetakeHost}>
      {t('收回主持人')}
    </li>
  );
};

export default RetakeHost;
